<div *transloco="let t; read: 'documents.delete'" class="xi-modal__container">
  <h2 class="xi-modal__title">{{ t('title') }}</h2>

  <div class="xi-modal__content">
    {{ t('content') }}

    <div class="document-delete__radio-buttons">
      @for (reason of reasons; track reason) {
        <div class="document-delete__radio-button">
          <xi-radio
            [value]="reason.value | titlecase"
            [(ngModel)]="deleteReason"
            [label]="reason.label"
            name="deleteReason"
          ></xi-radio>
        </div>
      }
    </div>
  </div>

  <div class="xi-modal__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="cancel()"></xi-default-button>

    <div class="fill-space"></div>

    <xi-default-button
      [text]="t('delete')"
      color="warning"
      [disabled]="deleteReason === undefined"
      (onClick)="confirm()"
    ></xi-default-button>
  </div>
</div>
